class EventModal {
    constructor() {
        this.modal = null;
        this.hasBeenShown = false;
        this.init();
    }

    init() {
        // Récupérer la modale existante dans le DOM
        this.modal = document.getElementById("eventModal");

        if (!this.modal) return;

        // Afficher la modale après un délai (1 seconde)
        setTimeout(() => {
            this.show();
        }, 1000);

        // Écouter directement la touche Escape
        this.handleKeydown = (event) => {
            if (event.key === "Escape" && this.modal.classList.contains("event-modal--visible")) {
                this.close();
            }
        };
        document.addEventListener("keydown", this.handleKeydown);

        // Écouter le clic sur le fond sombre
        this.modal.addEventListener("click", (e) => {
            if (e.target === this.modal) {
                this.close();
            }
        });

        // Écouter le clic sur le bouton fermer
        const closeBtn = this.modal.querySelector(".event-modal-close");
        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                this.close();
            });
        }
    }

    show() {
        if (!this.hasBeenShown && this.modal) {
            this.modal.classList.add("event-modal--visible");
            document.body.style.overflow = "hidden";
            this.hasBeenShown = true;
        }
    }

    close() {
        if (this.modal) {
            this.modal.classList.remove("event-modal--visible");
            document.body.style.overflow = "";

            // Retirer l'écouteur d'événement clavier
            if (this.handleKeydown) {
                document.removeEventListener("keydown", this.handleKeydown);
            }

            // Optionnel : supprimer complètement la modale après l'animation
            setTimeout(() => {
                if (this.modal && !this.modal.classList.contains("event-modal--visible")) {
                    this.modal.remove();
                }
            }, 300);
        }
    }
}